import apolloClient from "../apolloClient";
import { GET_USER } from "./graphql";

class UserService {
	getUserData = async () => {
		const response = await apolloClient.query({
			query: GET_USER,
		});
		const user = response.data.me2;
		return user;
	};
}

export default new UserService();
